// views/auth/register.pl.js  (PL)
export const register_i18n = {
  alts: {
    banner: "tło rejestracji",
    brand: "WA Checkin",
    footerLogo: "WA Checkin",
  },

  aria: {
    toggleReferral: "włącz lub wyłącz kod partnerski",
    togglePassword: "pokaż lub ukryj hasło",
  },

  texts: {
    inviteTitle: "Gratulacje!",
    inviteText: "{name} zaprasza do WACheckin: {percent}% zniżki przez pierwsze {months} miesiące.",
    inviteApplied: "Zastosowano na podstawie linku z zaproszenia.",
    panelKicker: "WACheckin · 2026",
    panelCta: "Poznaj WACheckin",
    langLabel: "Język",
    panelTitle: "Wystarczy jedna konfiguracja. Reszta dzieje się sama.",
    panelDesc: "Link do check-in, wiadomość powitalna, klucze i zgłoszenie na policję wychodzą same, bez konieczności pamiętania o tym.",
    title: "Utwórz konto",
    infoTitle: "Rejestracja w kilka minut",
    infoDesc:
      "Wystarczy uzupełnić dane, aby zacząć automatyzować check-in i komunikację z gośćmi.",
    referralHint: "Należy włączyć tylko wtedy, gdy taki kod został przekazany.",
    alreadyHaveAccount: "Konto już założone?",
  },

  labels: {
    inviteCode: "Kod zaproszenia",
    name: "Imię",
    email: "E-mail",
    password: "Hasło",
    phone: "Telefon",
    referralCode: "Kod partnerski",
  },

  placeholders: {
    name: "Wpisz imię",
    email: "Wpisz adres e-mail",
    password: "Utwórz hasło",
    referralCode: "Kod",
  },

  buttons: {
    submit: "Utwórz konto",
    submitting: "Tworzenie konta...",
    signIn: "Zaloguj się",
  },

  validation: {
    phoneRequired: "Należy wpisać numer telefonu, a nie sam numer kierunkowy.",
    phoneInvalid: "Ten numer jest nieprawidłowy. Proszę go sprawdzić.",
    invalidReferralCode: "Kod partnerski jest nieprawidłowy.",
  },

  toast: {
    signupSuccess: "Konto zostało utworzone!",
    referralCodeError:
      "Kod polecający jest nieprawidłowy. Należy wpisać poprawny kod lub pozostawić pole puste.",
    signupError: "Błąd podczas rejestracji.",
    networkError: "Błąd połączenia. Proszę spróbować ponownie.",
  },
};
